module.exports = __webpack_public_path__ + "static/media/tiipaper.8f19f878.png";